module.exports = __webpack_public_path__ + "static/media/s3-no-va.3b0d2ab3.png";